import React from "react";

import nary from "@/modules/nary";
import nth0WithSup from "@/modules/nth0WithSup";
import thousandsFormat from "@/modules/thousandsFormat";
import { assetImg } from "@/modules/moduleImporter";
import { IMachineGameResultHistoryProps } from "@/types/GameHistoryTypes";

import img_cross from "../../../assets/img/img_cross.png";

import "../m29/index.scss";
import Nnary from "@/modules/Nnary";

export default class M26 extends React.Component<IMachineGameResultHistoryProps> {
	private historyFragment() {
		const reversedHistory = this.props.history.slice(0).reverse();

		const { pcode } = this.props;

		return (
			//History
			<div className="history-container m26-history">
				<div className="ticket-header">
					{
						Nnary(0, pcode === "m42" ? 1 : 9).map(item =>
							<div key={item}>
								{nth0WithSup(item)}
							</div>
						)
					}
				</div>

				{
					(reversedHistory.slice(0, 9)).map((historyItem, rowIdx) =>
						<div className="row" key={"GRH_m26_" + rowIdx}>
							{
								historyItem.angka.split(",").map((item, idx) =>
									assetImg("m26", item + ".svg", "GRH_m26_" + rowIdx + "_" + idx)
								)
							}
						</div>
					)
				}
			</div>
		);
	}

	private runningTicketFragment() {
		const tickets = this.props.tickets || [];
		const hasTickets = tickets && tickets.length > 0;

		const classNames = [
			"m26-ticket",
			this.props.mustSubmitTickets ? " must-submit" : ""
		].join("");

		const {
			mustSubmitTickets,
			pcode,
			removeTicket,
			langdata
		} = this.props;

		if (!hasTickets) {
			return (
				<div className={classNames} body-scroll-lock-ignore="true">
					<div className="no-tickets">
						{langdata["txt_no_tickets"]}
					</div>
				</div>
			);
		}

		return (
			<div className={classNames} body-scroll-lock-ignore="true">
				{
					tickets
						.slice()

						// Add number 0 before numbers before 10
						.map(ticketItem => {
							ticketItem.tebak = ticketItem.tebak.padStart(2, "0");
							return ticketItem;
						})

						// Sort tickets by the first number (1 to 10)
						.sort((a, b) =>
							(a.tebak > b.tebak) ? 1 :
								(b.tebak > a.tebak) ? -1 : 0)

						// Render the tickets
						.map((ticketItem, index) => {
							const
								splitTebak = ticketItem.tebak.split(","),
								isPinball = pcode === "m42",
								isRandom = !isPinball && ticketItem.type === "random";

							return (
								<div className={"row " + ticketItem.type} key={"GRH_m26_ticket_" + index}>
									<div className="top">
										<div className="ticket-number">
											{index + 1}
										</div>

										<div className="ticket-type">
											{ticketItem.type.toUpperCase()}
										</div>

										<div className="numbers">
											{
												(
													isPinball
														? nary(2)
														: isRandom
															? nary(5)
															: nary(9)
												).map((item, idx) => {

													//Display numbers
													const
														splitItem = splitTebak[idx],
														key = "GRH_m29_ticket_" + index + "_" + idx;

													if (splitItem) {
														const
															assetKey = isPinball ? "m13" : "m26",
															assetName = Number(splitItem) + (isPinball ? "" : ".svg");

														return assetImg(assetKey, assetName, key);
													}

													return (
														<div className="empty" key={key}>
															{"\u00a0"}
														</div>
													);
												})
											}
										</div>

										{
											// After Rebet, shows a big cross emoji
											mustSubmitTickets &&
											<img className="remove-ticket"
												src={img_cross}
												alt="Remove ticket"

												{...{
													index,
													pcode
												}}

												onClick={removeTicket} />
										}
									</div>

									<div className="bottom">
										<div>BET: {thousandsFormat(ticketItem.taruhan, langdata.language_code)}</div>
										<div>PERIODE: {ticketItem.periode}</div>
									</div>
								</div>
							);
						})
				}
			</div>
		)
	}

	render() {
		const { type } = this.props;

		if (type !== "ticket")
			return this.historyFragment();

		// console.log("GRH m26 props", this.props);

		return this.runningTicketFragment();
	}
}